<template>
  <div class="page-inner">
    <v-btn color="mainColorLight" x-large block depressed @click="gotoSignIn">
      회원가입
    </v-btn>
  </div>
</template>
<script>
export default {
  components: { },
  methods: {
    gotoSignIn() {
      this.$router.push({ path: "/signup" }).catch(() => {});
    },
  },
};
</script>
